<div
  class="simple-counter d-flex justify-content-between align-items-center"
  [ngClass]="{ 'simple-counter__disabled': isComponentDisabled }"
>
  <span
    [ngClass]="{ 'simple-counter__symbols__disabled': isComponentDisabled }"
    class="simple-counter__symbols"
    (click)="decrease()"
    >-</span
  >
  <span [ngClass]="{ 'f-color-slate-20': isComponentDisabled }" class="mx-4"
    ><b>{{ currentValue }}</b></span
  >
  <span
    [ngClass]="{ 'simple-counter__symbols__disabled': isComponentDisabled }"
    class="simple-counter__symbols"
    (click)="increase()"
    >+</span
  >
</div>
